import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const Counter = ({ value, suffix = "", label, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const start = performance.now();
    const from = 0;
    const to = value;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.floor(from + (to - from) * eased));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);

  return (
    <div ref={ref} data-testid={testId} className="text-center md:text-left">
      <div className="flex items-baseline gap-1 justify-center md:justify-start">
        <span className="font-display font-bold text-[#003399] text-6xl md:text-7xl lg:text-8xl tracking-tight leading-none">{display}</span>
        <span className="font-display font-bold text-[#00E5FF] text-3xl md:text-4xl">{suffix}</span>
      </div>
      <div className="mt-3 text-xs tracking-[0.2em] uppercase text-[#4A5568] font-display">{label}</div>
    </div>
  );
};

export const SectionHeader = ({ eyebrow, title, subtitle, align = "left", light = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, ease: [0.2, 0.6, 0.2, 1] }}
    className={`${align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}`}
  >
    {eyebrow && <div className={`eyebrow ${light ? '!text-[#00E5FF]' : ''}`} style={light?{color:'#00E5FF'}:{}}>{eyebrow}</div>}
    <h2 className={`mt-4 font-display font-semibold text-3xl md:text-4xl lg:text-5xl tracking-tight ${light ? 'text-white' : 'text-[#0B1120]'}`}>{title}</h2>
    {subtitle && <p className={`mt-6 text-lg leading-relaxed font-light ${light ? 'text-white/70' : 'text-[#4A5568]'}`}>{subtitle}</p>}
  </motion.div>
);

export const PillLabel = ({ children, tone = "primary", testId }) => {
  const tones = {
    primary: "bg-[#003399] text-white",
    accent: "bg-[#00E5FF] text-[#003399]",
    ghost: "border border-[#003399] text-[#003399]",
    muted: "bg-slate-100 text-[#4A5568]",
  };
  return <span data-testid={testId} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[10px] tracking-[0.16em] uppercase font-display font-medium ${tones[tone]}`}>{children}</span>;
};
